import { AVATAR_ART_IMG_STYLE } from '../../utils/arena/avatarUtils';

// A player's profile picture: a Sorcery card image cropped to its
// illustration, with the name banner, type line, rules box and frame
// edges outside the box. The box must be square (every avatar surface
// is a circle or a square tile); `className` / `style` size, round and
// decorate it exactly like the <img> they used to style.
export default function AvatarImage({ src, alt = '', className = '', style, loading, ...rest }) {
  return (
    <div className={`relative overflow-hidden ${className}`} style={style} {...rest}>
      <img src={src} alt={alt} draggable={false} loading={loading} style={AVATAR_ART_IMG_STYLE} />
    </div>
  );
}
